'use client';

import { ChartColumn } from 'lucide-react';
import DashboardBlockEditorDataUnit from '@/components/features/dashboard/unit/DashboardBlockEditorDataUnit';
import Header from '@/components/modal/Header';

type Props = { onClose?: () => void };

export default function BoardEditorUsageData({ onClose }: Props) {
    return (
        <div className="w-full h-full overflow-y-auto p-4">
            <div className="flex flex-row w-full h-12">
                <div className="flex justify-end w-3/4">
                    <Header title="USAGE DATA" subTitle="" icon={ChartColumn} />
                </div>
            </div>

            <div className="flex flex-col w-full px-2">
                <DashboardBlockEditorDataUnit showTitle={false} />
            </div>
        </div>
    );
}
